import React from 'react';

import style from './BarDisplay.module.scss';

type BarDisplayProps = {
	x: number;
	y: number;
	width: number;
	height: number;
	barCornerRadius: number;
	barColor: string;
	barBorderColor: string;
	isFadeLeft?: boolean;
	isFadeRight?: boolean;
};

const BarDisplay: React.FC<BarDisplayProps> = ({
	x,
	y,
	width,
	height,
	barCornerRadius,
	barColor,
	barBorderColor,
	isFadeLeft = false,
	isFadeRight = false,
}) => {
	const isFadeMask = isFadeLeft || isFadeRight;
	const maskId = `mask-${x}-${y}`;

	const generateStops = () => {
		const stops = [];

		if (isFadeLeft) {
			stops.push(
				<stop
					key='left-0'
					offset='0%'
					stopColor='white'
					stopOpacity='0'
				/>,
			);

			stops.push(
				<stop
					key='left-10'
					offset='10%'
					stopColor='white'
					stopOpacity='1'
				/>,
			);
		} else {
			stops.push(
				<stop
					key='left-0'
					offset='0%'
					stopColor='white'
					stopOpacity='1'
				/>,
			);
		}

		if (isFadeRight) {
			stops.push(
				<stop
					key='right-90'
					offset='90%'
					stopColor='white'
					stopOpacity='1'
				/>,
			);

			stops.push(
				<stop
					key='right-100'
					offset='100%'
					stopColor='white'
					stopOpacity='0'
				/>,
			);
		} else {
			stops.push(
				<stop
					key='right-100'
					offset='100%'
					stopColor='white'
					stopOpacity='1'
				/>,
			);
		}

		return stops;
	};

	return (
		<g>
			{isFadeMask
				&& <defs>
					<linearGradient
						id={maskId}
						x1='0'
						x2='1'
						y1='0'
						y2='0'
					>
						{generateStops()}
					</linearGradient>

					<mask id={`mask-${maskId}`}>
						<rect
							fill={`url(#${maskId})`}
							height={height}
							rx={barCornerRadius}
							ry={barCornerRadius}
							width={width}
							x={x}
							y={y}
						/>
					</mask>
				</defs>
			}

			<rect
				className={style.barBackground}
				fill={barColor}
				height={height}
				mask={isFadeMask ? `url(#mask-${maskId})` : undefined}
				rx={barCornerRadius}
				ry={barCornerRadius}
				stroke={barBorderColor}
				width={width}
				x={x}
				y={y}
			/>
		</g>
	);
};

export default BarDisplay;
